export default __webpack_public_path__ + "static/media/ecom.a9d0df52.png";